import { render, staticRenderFns } from "./CourierNew.vue?vue&type=template&id=34e6ffd5&scoped=true&"
import script from "./CourierNew.vue?vue&type=script&lang=js&"
export * from "./CourierNew.vue?vue&type=script&lang=js&"
import style0 from "./CourierNew.vue?vue&type=style&index=0&id=34e6ffd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e6ffd5",
  null
  
)

export default component.exports